import { ReactNode } from 'react';

// Object defining all possible popover arrow positions
export const popoverPosition = {
  right: 'right',
  left: 'left',
  top: 'top',
  bottom: 'bottom',
};

export type PopoverPosition = keyof typeof popoverPosition;

export interface PopoverProps {
  /** Position of the popover relative to the trigger element */
  position?: PopoverPosition;
  /** Additional CSS classes for the container */
  className?: string;
  /** Content of the trigger element */
  label?: ReactNode;
  /** Children components to render in the popover content */
  children?: ReactNode;
  /** Whether the popover should show on hover (tooltip mode) */
  activeHover?: boolean;
  /** Custom width class for the popover */
  popoverClassWidth?: string;
  /** Whether to display as modal on medium screens */
  modalOnMediumScreen?: boolean;
}

export interface PopupContentProps {
  closePopup: () => void;
  position: PopoverPosition;
  className?: string;
  id: string;
  children: ReactNode;
  isHoverable: boolean;
  modalOnMediumScreen: boolean;
}
